import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as IconInfo } from '../../assets/icon/ic_info.svg';

const Text = ({
  text, textStyle, leftIcon, tooltip, styleContainer,
  bold, muted, italic, required, length, link
}) => {
  let tempText = text;
  let tooltipText = null;
  if (length && text?.length > length) {
    tempText = text.slice(0, length);
    tooltipText = ' ...';
  }
  return (
    <div className={`relative flex flex-row items-center ${styleContainer}`}>
      {leftIcon}
      <div
        className={`
        ${muted ? 'text-[13px] text-text-muted dark:text-text-muted' 
          : 'text-[14px] text-text-main dark:text-secondary'} 
        ${textStyle} 
        ${leftIcon ? 'pl-[5px]' : ''} 
        ${italic ? 'italic' : ''} 
        ${link ? 'globalLink' : ''} 
        ${bold ? 'font-semibold' : ''}`}
      >
        {tempText}
        {required && <span className="text-danger px-[5px]">*</span>}
      </div>

      {(tooltipText || tooltip) && (
        <div className="group cursor-pointer flex">
          {tooltipText || <IconInfo className="w-[15px] h-[15px] text-[#A1A5B7] ml-[5px]" />}
          <div className="hidden group-hover:block text-center absolute bottom-[25px] bg-white
           dark:bg-background-dark p-[13px]
           rounded-[8px] font-sans text-text-main dark:text-secondary min-w-[150px] shadow-default"
          >
            {tooltip || text}
          </div>
        </div>
      )}
    </div>
  );
};

Text.propTypes = {
  text: PropTypes.string,
  textStyle: PropTypes.string,
  styleContainer: PropTypes.string,
  leftIcon: PropTypes.node,
  tooltip: PropTypes.node,
  bold: PropTypes.bool,
  muted: PropTypes.bool,
  italic: PropTypes.bool,
  required: PropTypes.bool,
  link: PropTypes.bool,
  length: PropTypes.number,
};

Text.defaultProps = {
  text: '',
  textStyle: '',
  styleContainer: '',
  leftIcon: undefined,
  tooltip: undefined,
  bold: false,
  muted: false,
  italic: false,
  required: false,
  link: false,
  length: null
};

export default Text;
